module.exports = __webpack_public_path__ + "img/1-B-exploration-drilling-bg.00105474.png";